import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import closeIcon from 'images/icon/close_icon-28x29.png';
import presenterIcon from 'images/icon/presenter_icon-210x152.png'

export default function PersonalDataUpdateModal({ setVisible, onKakaoSync, campaignNo }) {
    return (
        
            <ModalBlock>
                <ModalHeader>
                    <CloseBtnBlock onClick={() => setVisible(false)}>
                        <CloseBtn src={closeIcon}/>
                    </CloseBtnBlock>
                </ModalHeader>
                <ModalBody>
                    <ModalImgBlock>
                        <ModalImg src={presenterIcon} />
                    </ModalImgBlock>
                    <ModalDesc>{`챌린지 안내 및 원활한 상품 수령을 위해\n정확한 추가 정보가 필요해요!`}</ModalDesc>
                    <ModalBtnBlock>
                        <KakaoSyncBtn onClick={onKakaoSync}>카카오 빠르게 연동하기</KakaoSyncBtn>
                        <AddPersonalDataBtn to={`/write/personal?redirect_path=/campaign/${campaignNo}/join`} >추가 정보 입력하기</AddPersonalDataBtn>
                    </ModalBtnBlock>
                </ModalBody>
            </ModalBlock>
    )
}

const ModalBlock = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: calc(100vw * (284 / 375));
    border-radius: 10px;
`;

const ModalHeader = styled.div`
    flex: 0 1 auto;
    padding:  calc(100vw * (14 / 375)) calc(100vw * (17 / 375));
`;

const CloseBtnBlock = styled.div`
    width: calc(100vw * (14 / 375));
    height: calc(100vw * (14 / 375));
`;

const CloseBtn = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const ModalBody = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const ModalImgBlock = styled.div`
    width: calc(100vw * (105 / 375));
    height: calc(100vw * (76 / 375));
`;

const ModalImg = styled.img`
    width: 100%;
    height: 1005;
    object-fit: contain;
`;

const ModalDesc = styled.p`
    font-size: calc(100vw * (14 / 375));
    font-weight: 400;
    line-height: calc(100vw * (20 / 375));
    text-align: center;
    color: #000;
    width: 100%;
    margin-top: calc(100vw * (17 / 375));
    padding: 0 calc(100vw * (29 / 375));

`;

const ModalBtnBlock = styled.div`
    width: 100%;
    margin-top: calc(100vw * (32 / 375));
    padding: 0 calc(100vw * (11 / 375)) calc(100vw * (6 / 375)) calc(100vw * (11 / 375));
`;

const buttonStyle = css`
    font-size: calc(100vw * (14 / 375));
    width: 100%;
    padding: calc(100vw * (15 / 375)) 0;
    text-align: center;
`;

const KakaoSyncBtn = styled.button`
    ${buttonStyle}
    font-weight: 500;
    background-color: #FAE100;
    color: #371D1E;
    border-radius: 6px;
`

const AddPersonalDataBtn = styled(Link)`
    ${buttonStyle}
    font-weight: 400;
    color: #7F7F7F;
`;
